import type { FaireProductEntity } from "../../entity_types/product";

export const p_cevimg6x: FaireProductEntity = {
  token: "p_cevimg6x",
  type: "product",
  name: "Whale Thanks Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/68f78cb3235e760d3f96877deeee7cbd1ce9c42afc9aed99f2af78c04d16b44d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/6cf1c9a62bbc4dc62c004a879ddfd01dac10bfa90aeb269d1e434aa0a91364d9/1528385985.png",
    "https://cdn.faire.com/fastly/a14c88521ab61193fb32f43e15d1bc24ea77da02165d98a087e21164c002c030.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:58.144Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
